import { LOGIN, FORGOT_PASSWORD, CHANGE_PASSWORD, USERS } from '../constants/actions';
import { fromPath } from '../selectors/router';
import { apiActionCreator } from './helpers';
import { users } from '../services/api';
import { LOGIN_PATH, ROOT_PATH, FORGOT_PASSWORD_MAIL_PATH, CHANGE_PASSWORD_SUCCESS_PATH } from '../constants/routes';
import { storeToken, clearToken, getTokenLocal } from '../services/local.storage';
import {
    emailSelector,
    userFetchedSelector,
    userEmailSelector,
    rememberMeSelector,
    userIdSelector,
    favoriteArtistsSelector,
    preferencesSelector
} from '../selectors/authentication';
import { push } from 'react-router-redux';
import { BAD_REQUEST_CODE, UNAUTHORIZED_CODE, FORBIDDEN_CODE, GONE_CODE } from '../constants/http.codes';
import { compact, filter, omit, uniq } from 'lodash';
import { openFlash } from './global';

export function logOut() {
    return dispatch => {
        clearToken();
        dispatch(push(LOGIN_PATH));
        dispatch({ type: LOGIN.CANCEL });
    };
}
export function inputForgotPassword(value, key) {
    return {
        type: FORGOT_PASSWORD.INPUT,
        key: key,
        value: value
    };
}
export function inputChangePassword(value, key) {
    return {
        type: CHANGE_PASSWORD.INPUT,
        key: key,
        value: value
    };
}
export function inputLogin(value, key) {
    return {
        type: LOGIN.INPUT,
        key: key,
        value: value
    };
}

export function submitForgotPasswordForm(email) {
    return async (dispatch, getState) => {
        dispatch({
            type: FORGOT_PASSWORD.SUBMIT
        });
        await apiActionCreator(
            dispatch,
            () => users.reset(email.toLowerCase()),
            () => {
                dispatch({ type: FORGOT_PASSWORD.SUCCESS, email: emailSelector(getState()) });
                dispatch(push(FORGOT_PASSWORD_MAIL_PATH));
            },
            {
                allErrors: e => {
                    dispatch({ type: FORGOT_PASSWORD.FAILED });
                }
            }
        );
    };
}

export function setNotificationsSeen() {
    return async dispatch => {
        dispatch({ type: USERS.UPDATE, field: 'notificationsSeenAt', value: new Date().toISOString() });
        return apiActionCreator(dispatch, users.setNotificationsSeen, () => {});
    };
}

export function acceptTos() {
    return async dispatch => {
        await apiActionCreator(dispatch, users.acceptTos, () => {
            dispatch({ type: USERS.UPDATE, field: 'tosAndPrivacy', value: true });
        });
    };
}

export function submitChangePassword(oldPassword, newPassword) {
    return async (dispatch, getState) => {
        dispatch({
            type: CHANGE_PASSWORD.SUBMIT
        });
        const email = userEmailSelector(getState());
        const id = userIdSelector(getState());

        await apiActionCreator(
            dispatch,
            () => users.changePassword(id, { email, oldPassword, newPassword }),
            () => {
                dispatch({ type: CHANGE_PASSWORD.SUCCESS });
                dispatch(push(CHANGE_PASSWORD_SUCCESS_PATH));
            },
            {
                allErrors: e => {
                    dispatch({ type: CHANGE_PASSWORD.FAILED });
                }
            }
        );
    };
}

export function submitLoginForm(email, password) {
    return async (dispatch, getState) => {
        dispatch({
            type: LOGIN.SUBMIT
        });
        await apiActionCreator(
            dispatch,
            () => users.login(email.toLowerCase(), password),
            response => {
                _loginSuccess(response, dispatch, getState);
            },
            {
                [GONE_CODE]: () => {
                    dispatch(
                        openFlash(
                            "Hello, we've made some changes to the Clear'em software and a new password has been sent to your e-mail address. Thank you!",
                            'warning'
                        )
                    );
                    dispatch({ type: LOGIN.REFRESH });
                },
                allErrors: () => {
                    dispatch({ type: LOGIN.FAILED });
                }
            }
        );
    };
}

function _loginSuccess(response, dispatch, getState) {
    const redirect = fromPath(getState()) || ROOT_PATH;
    storeToken(response.token, rememberMeSelector(getState()));
    dispatch({
        type: LOGIN.SUCCESS,
        user: { ...omit(response, 'token'), email: emailSelector(getState()) }
    });
    dispatch(push(redirect));
}

export function fetchUserProfile() {
    return async (dispatch, getState) => {
        if (!userFetchedSelector(getState())) {
            await apiActionCreator(
                dispatch,
                () => users.profile(),
                response => {
                    storeToken(response.token, !!getTokenLocal());
                    dispatch({
                        type: USERS.FETCH_OK,
                        user: { ...omit(response, 'token') }
                    });
                },
                {
                    [BAD_REQUEST_CODE]: () => logOut()(dispatch),
                    [UNAUTHORIZED_CODE]: () => logOut()(dispatch),
                    [FORBIDDEN_CODE]: () => logOut()(dispatch)
                }
            );
        }
    };
}

export function favOrUnfavArtist(id) {
    return (dispatch, gs) => {
        if (id) {
            const favorites = favoriteArtistsSelector(gs());
            const newFavs = compact(
                uniq(favorites.includes(id) ? filter(favorites, x => x !== id) : [...favorites, id])
            );
            dispatch({ type: USERS.UPDATE, field: 'favoriteArtists', value: newFavs });
            return apiActionCreator(
                dispatch,
                () => users.setFavorites(newFavs),
                () => {}
            );
        }
    };
}

export function savePreferences(key, prefs = {}) {
    return async (dispatch, getState) => {
        let preferences = { ...preferencesSelector(getState()) };
        if (key) {
            preferences[key] = { ...(preferences[key] || {}), ...prefs };
        } else {
            preferences = { ...preferences, ...prefs };
        }
        dispatch({ type: USERS.UPDATE, field: 'preferences', value: preferences });
        return apiActionCreator(
            dispatch,
            () => users.setPreferences(preferences),
            () => {}
        );
    };
}



// WEBPACK FOOTER //
// ./src/actions/authentication.js